/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="113.14" height="94.33" viewBox="0 0 113.14 94.33" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="fd2b4aae-5db9-4eb7-a927-dd90b98cfa24" x="45.1" y="65.82" width="2.5" height="28.52" maskUnits="userSpaceOnUse">
            <g transform="translate(-21 -29.5)">
              <polygon points="66.85 95.32 67.85 95.32 67.85 123.83 66.85 123.83 66.85 95.32" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
          <mask id="b02c4e26-96b6-426b-ae41-3c41ea053b99" x="51.62" y="79.7" width="2.5" height="14.64" maskUnits="userSpaceOnUse">
            <g transform="translate(-21 -29.5)">
              <polygon points="73.37 109.2 74.37 109.2 74.37 123.83 73.37 123.83 73.37 109.2" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
          <mask id="ace844b3-dcf0-4ae5-90bc-ec21ce835b38" x="58.15" y="65.82" width="2.5" height="28.52" maskUnits="userSpaceOnUse">
            <g transform="translate(-21 -29.5)">
              <polygon points="79.9 95.32 80.9 95.32 80.9 123.83 79.9 123.83 79.9 95.32" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <g>
          <path d="M71.1,29.5h-.45a7.8,7.8,0,0,0-7.78,7.78v.25a7.73,7.73,0,0,0,2.57,5.78L75,53.07a1.25,1.25,0,0,0,1.78,0l.93-.93,8.61-8.84a7.72,7.72,0,0,0,2.58-5.78v-.24a7.79,7.79,0,0,0-7.78-7.79h-.76A7.68,7.68,0,0,0,76.09,31l-.21.16L75.67,31A7.77,7.77,0,0,0,71.1,29.5ZM70.66,32h.44a5.26,5.26,0,0,1,3.74,1.55l.16.16a1.26,1.26,0,0,0,1.76,0l.16-.16A5.26,5.26,0,0,1,80.66,32h.45a5.28,5.28,0,0,1,5.28,5.29v.24a5.25,5.25,0,0,1-1.8,4L75.9,50.42,67.17,41.5a5.28,5.28,0,0,1-1.8-4v-.24A5.29,5.29,0,0,1,70.66,32Z" transform="translate(-21 -29.5)" fill="#ffb81c"/>
          <g>
            <line x1="17.23" y1="83.79" x2="17.23" y2="94.33" fill="none"/>
            <polygon points="18.48 83.78 18.48 94.33 15.98 94.33 15.98 83.78 18.48 83.78" fill="#0e497b"/>
          </g>
          <g>
            <line x1="17.23" y1="63.33" x2="17.23" y2="83.78" fill="none"/>
            <path d="M38.24,91.58a1.25,1.25,0,0,1,1.24,1.12v20.59a1.25,1.25,0,0,1-2.49.12V92.83A1.24,1.24,0,0,1,38.24,91.58Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          </g>
          <g>
            <line x1="8.53" y1="83.79" x2="8.53" y2="94.33" fill="none"/>
            <polygon points="9.78 83.79 9.78 94.33 7.28 94.33 7.28 83.79 9.78 83.79" fill="#0e497b"/>
          </g>
          <g>
            <line x1="8.53" y1="43.59" x2="8.53" y2="83.79" fill="none"/>
            <path d="M29.53,71.84A1.27,1.27,0,0,1,30.78,73v40.32a1.25,1.25,0,0,1-2.49.12V73.09A1.25,1.25,0,0,1,29.53,71.84Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          </g>
          <path d="M38.23,36.45a9.19,9.19,0,1,0,9.19,9.18A9.18,9.18,0,0,0,38.23,36.45Zm0,2.5a6.69,6.69,0,1,1-6.68,6.68A6.68,6.68,0,0,1,38.23,39Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <g>
            <polygon points="25.43 83.79 26.43 83.79 26.43 94.33 25.43 94.33 25.43 83.79" fill="none"/>
            <line x1="25.93" y1="83.79" x2="25.93" y2="94.33" fill="none"/>
            <polygon points="27.18 83.79 27.18 94.33 24.68 94.33 24.68 83.79 27.18 83.79" fill="#0e497b"/>
          </g>
          <g>
            <line x1="25.93" y1="43.59" x2="25.93" y2="83.79" fill="none"/>
            <path d="M46.93,71.84A1.27,1.27,0,0,1,48.18,73v40.32a1.25,1.25,0,0,1-2.49.12V73.09A1.25,1.25,0,0,1,46.93,71.84Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          </g>
          <path d="M44.83,57.57A10.64,10.64,0,0,1,55.46,67.93V90.64A3.7,3.7,0,0,1,52,94.13h-5a1.25,1.25,0,0,1-.12-2.49h5A1.19,1.19,0,0,0,53,90.56V68.21a8.15,8.15,0,0,0-7.9-8.14H31.64A8.13,8.13,0,0,0,23.51,68V90.44a1.19,1.19,0,0,0,1.07,1.19h5a1.25,1.25,0,0,1,.13,2.5h-5A3.69,3.69,0,0,1,21,90.64V68.21A10.64,10.64,0,0,1,31.36,57.57H44.83Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <g>
            <line x1="92.21" y1="74.7" x2="92.21" y2="94.33" fill="none"/>
            <polygon points="93.46 74.7 93.46 94.33 90.96 94.33 90.96 74.7 93.46 74.7" fill="#0e497b"/>
          </g>
          <g>
            <line x1="100.91" y1="74.7" x2="100.91" y2="94.33" fill="none"/>
            <polygon points="102.16 74.7 102.16 94.33 99.66 94.33 99.66 74.7 102.16 74.7" fill="#0e497b"/>
          </g>
          <path d="M127.37,64.07a1.26,1.26,0,0,1,1.45.83l0,.13,5.19,23.59,0,.19A3.69,3.69,0,0,1,131.43,93l-.19,0-4.73,1a1.25,1.25,0,0,1-.66-2.4l.13,0,4.72-1a1.19,1.19,0,0,0,.93-1.3l0-.14-5.2-23.58a1.26,1.26,0,0,1,.83-1.45Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <g>
            <line x1="83.51" y1="74.7" x2="83.51" y2="94.33" fill="none"/>
            <polygon points="84.76 74.7 84.76 94.33 82.26 94.33 82.26 74.7 84.76 74.7" fill="#0e497b"/>
          </g>
          <path d="M113.21,36.45a9.19,9.19,0,1,0,9.19,9.18A9.19,9.19,0,0,0,113.21,36.45Zm0,2.5a6.69,6.69,0,1,1-6.69,6.68A6.69,6.69,0,0,1,113.21,39Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <g>
            <line x1="100.91" y1="74.7" x2="100.91" y2="94.33" fill="none"/>
            <polygon points="102.16 74.7 102.16 94.33 99.66 94.33 99.66 74.7 102.16 74.7" fill="#0e497b"/>
          </g>
          <path d="M121.63,71.87a1.25,1.25,0,0,1,1.46.83l0,.13,6.84,31.1a1.24,1.24,0,0,1-1.09,1.51H97.68a1.25,1.25,0,0,1-1.24-1.4l0-.12,6.84-31.1a1.25,1.25,0,0,1,2.46.41l0,.12L99.23,103h28l-6.51-29.59a1.25,1.25,0,0,1,.83-1.45Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M97.57,65a1.25,1.25,0,0,1,2.46.41l0,.12-5.2,23.6a1.2,1.2,0,0,0,.79,1.39l.12,0,4.72,1a1.25,1.25,0,0,1-.41,2.46l-.12,0-4.73-1a3.69,3.69,0,0,1-2.85-4.21l0-.19Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M119.8,57.57a9.22,9.22,0,0,1,9.06,7.49,1.25,1.25,0,1,1-2.45.47,6.75,6.75,0,0,0-6.36-5.46H106.62A6.73,6.73,0,0,0,100,65.53a1.25,1.25,0,1,1-2.45-.47,9.23,9.23,0,0,1,8.79-7.49H119.8Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M73.87,105.78a1.27,1.27,0,0,1,1.25,1.13v14.76a1.25,1.25,0,0,1-2.49.13V107A1.25,1.25,0,0,1,73.87,105.78Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M67.35,91.9A1.25,1.25,0,0,1,68.59,93v28.64a1.25,1.25,0,0,1-2.49.13V93.15A1.25,1.25,0,0,1,67.35,91.9Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M73.87,105.78a1.27,1.27,0,0,1,1.25,1.13v14.76a1.25,1.25,0,0,1-2.49.13V107A1.25,1.25,0,0,1,73.87,105.78Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M80.4,91.9A1.25,1.25,0,0,1,81.64,93v28.64a1.25,1.25,0,0,1-2.49.13V93.15A1.25,1.25,0,0,1,80.4,91.9Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M73.87,105.78a1.27,1.27,0,0,1,1.25,1.13v14.76a1.25,1.25,0,0,1-2.49.13V107A1.25,1.25,0,0,1,73.87,105.78Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <g>
            <g mask="url(#fd2b4aae-5db9-4eb7-a927-dd90b98cfa24)">
              <polygon points="47.6 65.82 47.6 94.33 45.1 94.33 45.1 65.82 47.6 65.82" fill="#0e497b"/>
            </g>
          </g>
          <g>
            <g mask="url(#b02c4e26-96b6-426b-ae41-3c41ea053b99)">
              <polygon points="54.12 79.7 54.12 94.33 51.62 94.33 51.62 79.7 54.12 79.7" fill="#0e497b"/>
            </g>
          </g>
          <g>
            <g mask="url(#ace844b3-dcf0-4ae5-90bc-ec21ce835b38)">
              <polygon points="60.65 65.82 60.65 94.33 58.15 94.33 58.15 65.82 60.65 65.82" fill="#0e497b"/>
            </g>
          </g>
          <path d="M80,82.9a7.25,7.25,0,0,1,7.25,7v12.25a1.25,1.25,0,0,1-1.13,1.24H80.4a1.25,1.25,0,0,1-.13-2.49h4.51V90.15a4.74,4.74,0,0,0-4.54-4.74H67.73A4.75,4.75,0,0,0,63,89.94v11h4.38A1.24,1.24,0,0,1,68.59,102v.13a1.24,1.24,0,0,1-1.12,1.24H61.72a1.25,1.25,0,0,1-1.24-1.12V90.15a7.26,7.26,0,0,1,7-7.25H80Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
          <path d="M73.87,65.7a7.23,7.23,0,1,0,7.23,7.22A7.22,7.22,0,0,0,73.87,65.7Zm0,2.5a4.73,4.73,0,1,1-4.72,4.72A4.73,4.73,0,0,1,73.87,68.2Z" transform="translate(-21 -29.5)" fill="#0e497b"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'FamilyHeartIcon';

export default Icon;
